import { selectors } from 'modules/common';
import { domain } from 'modules/data';

import { messages } from './VersionHistoryItem.messages';

export const getVersionTypeDescription = (options: {
    version: keyof typeof domain.RequestVersionType;
    integrationType: domain.IntegrationType;
    isDextRequest: boolean;
    userName: string;
}) => {
    const { version, integrationType, isDextRequest, userName } = options;

    const integrationName = isDextRequest
        ? messages.dext
        : selectors.integration.getIntegrationTypeName(integrationType);

    switch (version) {
        case domain.RequestVersionType.RequesterSubmitted:
            return messages.requesterSubmitted;

        case domain.RequestVersionType.SubmittedViaExternalSystem:
            return messages.submittedViaExternalSystem({ integrationName });

        case domain.RequestVersionType.StartOverByExternalUpdate:
            return messages.startOverByExternalUpdate({ integrationName });

        case domain.RequestVersionType.RequesterResubmitted:
            return messages.requesterResubmitted;

        case domain.RequestVersionType.ReviewerEdited:
            return messages.reviewerEdited({
                userName,
            });

        case domain.RequestVersionType.EditorEdited:
        case domain.RequestVersionType.ApproverEdited:
            return messages.approverEdited({
                userName,
            });

        case domain.RequestVersionType.PostApprovalChangesDetected:
            return messages.postApprovalChangesDetected;

        default:
            return null;
    }
};
